// SPDX-FileCopyrightText: 2021 - 2022 Dusan Mijatovic (dv4all)
// SPDX-FileCopyrightText: 2021 - 2022 dv4all
// SPDX-FileCopyrightText: 2024 - 2025 Dusan Mijatovic (Netherlands eScience Center)
// SPDX-FileCopyrightText: 2024 - 2025 Netherlands eScience Center
//
// SPDX-License-Identifier: Apache-2.0

export const rowsPerPageOptions = [12, 24, 48]

export const defaultPagination = {
  count: 0,
  page: 0,
  rows: 12,
  rowsOptions: rowsPerPageOptions,
  labelRowsPerPage:'Per page'
}


// export const rowsPerPageOrganisation = [6, 12, 24]
